import { Outlet, Route, Routes } from "react-router-dom";
import routes from "./utils/routes";
import FinEaseAdminLayout from "./layouts/FineaseAdminLayout";

const FinEaseHomeApp = () => {
  const publicRoutes = routes.find(m => m.type === "public")?.routes ?? [];
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];
  return (
    <Routes>
      <Route element={<Outlet />}>
        {publicRoutes.map(({ path, element: Page }) => (
          <Route key={path} path={path} element={<Page />} />
        ))}
        <Route element={<FinEaseAdminLayout />}>
          {authRoutes.map(({ path, element: Page }) => (
            <Route key={path} path={path} element={<Page />} />
          ))}
        </Route>
      </Route>
    </Routes>
  );
};

export default FinEaseHomeApp;
